var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975 2239 c-257 -37 -482 -154 -665 -345 -136 -143 -217 -289 -274 -494 -67 -245 -34 -542 87 -785 112 -224 344 -438 573 -527 301 -117 557 -117 858 0 229 89 461 303 573 527 74 147 123 352 123 510 0 158 -49 363 -123 510 -62 125 -201 291 -317 380 -239 181 -549 265 -835 224z m260 -89 c411 -47 752 -329 874 -725 80 -259 54 -536 -72 -779 -189 -365 -606 -590 -1012 -546 -491 52 -871 431 -925 920 -28 255 53 538 211 735 144 179 299 286 511 354 143 45 265 57 413 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093 1680 c-49 -20 -59 -96 -17 -129 15 -12 37 -21 49 -21 38 0 75 37 75 75 0 58 -55 97 -107 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 983 l0 -423 45 0 45 0 0 423 0 422 -45 0 -45 0 0 -422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.4e3b7a92f68710a837c201e7a4bacc50.svg";
export { ForwardRef as ReactComponent };